module.exports = __webpack_public_path__ + "static/cicamon-f08a623ea499f7d338c6ee32988227fd.jpg";